import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useBusinessName } from '../contexts/BusinessContext';

export const warrantyActive = (job) => Boolean(job.warranty_expires_at && new Date(job.warranty_expires_at) > new Date());
export const warrantyDate = (value, timeZone) => value ? new Intl.DateTimeFormat('en-AU', {
  dateStyle: 'medium', timeStyle: 'short', ...(timeZone ? { timeZone } : {}),
}).format(new Date(value)) : 'Not started';

export const WarrantyStatus = ({ appointment, link = true, scope = '' }) => {
  const { businessTimezone } = useBusinessName();
  const id = scope ? `${scope}-${appointment.id}` : appointment.id;
  if (appointment.warranty_parent_id) return (
    <div className="warranty-status" data-testid={`warranty-ticket-label-${id}`}>
      <span>Warranty ticket · Non-billable</span>
      {link && <Link data-testid={`warranty-parent-link-${id}`} to={`/warranties?rollout=${appointment.warranty_parent_id}`}>View original rollout →</Link>}
    </div>
  );
  if (appointment.job_type !== 'New Desktop Rollout') return null;
  const active = warrantyActive(appointment);
  return (
    <div className="warranty-status" data-testid={`warranty-status-${id}`}>
      <span className="flex items-center gap-2"><ShieldCheck size={18} aria-hidden="true" />
        {appointment.warranty_expires_at ? `30-day warranty · ${active ? 'Active' : 'Expired'}` : '30-day warranty · Awaiting completion'}
      </span>
      {appointment.warranty_expires_at && <span data-testid={`warranty-expiry-${id}`}>Expires {warrantyDate(appointment.warranty_expires_at, businessTimezone)}{businessTimezone ? ` (${businessTimezone})` : ''}</span>}
      {link && appointment.warranty_expires_at && <Link data-testid={`warranty-manage-link-${id}`} to={`/warranties?rollout=${appointment.id}`}>Warranty & tickets →</Link>}
    </div>
  );
};